import { syntaxTree } from "@codemirror/language";
import { ancestorOfNodeWithType } from "components/organisms/manuscript/editor/latex/tree/ancestors";
export const ifInType = (type, source) => {
    return (context) => {
        const tree = syntaxTree(context.state);
        let node = tree.resolveInner(context.pos, -1);
        while (node) {
            if (node.type.is(type)) {
                return source(context);
            }
            node = node.parent;
        }
        return null;
    };
};
function isInEmptyArgumentNodeOfType(state, types) {
    const main = state.selection.main;
    if (!main.empty) {
        return false;
    }
    const pos = main.anchor;
    const tree = syntaxTree(state);
    if (tree.length < pos) {
        return false;
    }
    const nodeLeft = tree.resolveInner(pos, -1);
    if (!nodeLeft.type.is("OpenBrace")) {
        return false;
    }
    const nodeRight = tree.resolveInner(pos, 1);
    if (!nodeRight.type.is("CloseBrace")) {
        return false;
    }
    const ancestor = ancestorOfNodeWithType(nodeLeft, ...types);
    if (!ancestor) {
        return false;
    }
    return ancestor.from === nodeLeft.from && ancestor.to === nodeRight.to;
}
export function isInEmptyArgumentNodeForAutocomplete(state) {
    return isInEmptyArgumentNodeOfType(state, [
        "EnvNameGroup",
        "BibliographyStyleArgument",
        "BibliographyArgument",
        "BibKeyArgument",
        "DocumentClassArgument",
        "FilePathArgument",
        "RefArgument",
        "PackageArgument",
    ]);
}
export function isInEmptyCiteArgumentNode(state) {
    return isInEmptyArgumentNodeOfType(state, ["BibKeyArgument"]);
}
